import {Injectable} from '@angular/core';
import {SynthesisViewConfig} from "../../../models/synthesis/synthesis-view-config.model";
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteSynthesisViewConfigRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {}

    async getSynthesisViewConfigs(): Promise<SynthesisViewConfig[]> {
        const rawSynthesisViewConfigs: any[] = await this.parametersDatabase.queryObjects<any>(
            `SELECT *
         FROM synthesisviewconfig`,
            null,
            []
        );

        return rawSynthesisViewConfigs.map(rawConfig => {
            const processedConfig = {
                ...rawConfig,
                enabled: rawConfig.enabled === "1",
                isDefault: rawConfig.isDefault === "1"
            };
            const synthesisViewConfig = new SynthesisViewConfig();
            Object.assign(synthesisViewConfig, processedConfig);
            return synthesisViewConfig;
        });
    }
}
